module.exports = __webpack_public_path__ + "img/save-money-time.0b00477a.svg";